export default "__VITE_ASSET__Dke2yWzr__"